
import React from "react";

export const DownloadIcon: React.FC = () => {
  return (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7067_167)">
      <path d="M8.67993 2.40202V8.78202L10.1199 7.34202C10.3799 7.08202 10.7999 7.08202 11.0599 7.34202C11.3199 7.60202 11.3199 8.02202 11.0599 8.28202L8.5066 10.8354C8.2466 11.0954 7.8266 11.0954 7.5666 10.8354L4.99993 8.26869C4.73993 8.00869 4.73993 7.58868 4.99993 7.32868C5.25993 7.06868 5.67993 7.06868 5.93993 7.32868L7.3466 8.73535V2.40202C7.3466 2.03535 7.6466 1.73535 8.01327 1.73535C8.37993 1.73535 8.67993 2.03535 8.67993 2.40202Z" fill="#6C757D"/>
      <path d="M13.2933 9.91569V12.3424H2.63997V9.91569C2.63997 9.54902 2.33997 9.24902 1.97331 9.24902C1.60664 9.24902 1.30664 9.54902 1.30664 9.91569V13.009C1.30664 13.3757 1.60664 13.6757 1.97331 13.6757H13.96C14.3266 13.6757 14.6266 13.3757 14.6266 13.009V9.91569C14.6266 9.54902 14.3266 9.24902 13.96 9.24902C13.5933 9.24902 13.2933 9.54902 13.2933 9.91569Z" fill="#6C757D"/>
    </g>
    <defs>
      <clipPath id="clip0_7067_167">
        <rect width="16" height="16" fill="white" transform="translate(0 0.369141)"/>
      </clipPath>
    </defs>
  </svg>
  );
};
